import React from 'react'
import PropTypes from 'prop-types'
import { Table as AntTable } from 'antd'
import './table.scss'

const Table = ({
  dataSource,
  columns,
  rowKey,
  pagination = { pageSize: 10, showSizeChanger: true },
  loading = false,
  rowSelection,
  onChange,
  className = '',
  scroll,
  ...props
}) => {
  const tableClass = `app-table ${className}`

  return (
    <AntTable
      dataSource={dataSource}
      columns={columns}
      rowKey={rowKey}
      pagination={pagination}
      loading={loading}
      rowSelection={rowSelection}
      onChange={onChange}
      className={tableClass}
      scroll={scroll}
      {...props}
    />
  )
}

Table.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  loading: PropTypes.bool,
  rowSelection: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  scroll: PropTypes.object
}

export default Table